import { Component, Input } from '@angular/core'
import { FormControl } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { TranslateModule } from '@ngx-translate/core'
import { DatePipe, NgIf } from '@angular/common'

@Component({
  standalone: true,
  imports: [MatFormFieldModule, TranslateModule, NgIf, DatePipe],
  selector: 'app-form-errors',
  templateUrl: './form-errors.component.html',
  styleUrls: ['./form-errors.component.scss'],
})
export class FormErrorsComponent {
  @Input() control: FormControl
  @Input() minDate: Date
  @Input() maxDate: Date
  @Input() minLength: number
  @Input() maxLength: number
  @Input() title: string
}
